import NetworkApiModel from 'models/global/NetworkApiModel';
import { computed }    from 'mobx';

export default class ContactModel extends NetworkApiModel {
	static get path(): string {
		return '/contacts/{?id}';
	}

	@computed
	public get firstname(): string {
		return this.get('firstname');
	}

	@computed
	public get lastname(): string {
		return this.get('lastname');
	}

	@computed
	public get email(): string {
		return this.get('email');
	}
}
